import { stringToHTML } from '../utils/to-html';
import { $Q, $Qll } from '../utils/query-selector';
import { setQuantity } from "../utils/input-quantity";
import { btnAddToCart, deleteItem, onChangeItemCart } from "./cart";
import { configUpsellCart } from './slider-defer';
import { configArrows } from './slider-swiper';

/**
 * It assigns items depending on sidecart or cartpage
 * @param {string} str - String HTML of section rendering
 */
const assignDiffCarts = (str) => {
  if (str.includes('cartpage') && $Q('.cartpage .cartitems-js')) {
    $Q('.cartpage .cartitems-js').innerHTML = $Q(
      '#cart-items',
      stringToHTML(str)
    ).outerHTML;
  } else {
    $Q('#side-cart .cartitems-js').innerHTML = $Q(
      '#cart-items',
      stringToHTML(str)
    ).outerHTML;
  }
}

/**
 * It hides or shows the indicator for cart count on header
 * @param {String} str : It is the response from header section rendering
 */
export const updateHeaderCount = (str) => {
  const body = stringToHTML(str);

  const countFetched = $Q('.button-cart__count', body);
  const countDOM = $Q('.button-cart__count');

  if (countFetched.classList.contains('hidden')) {
    countDOM.classList.add('hidden')
  } else {
    countDOM.classList.remove('hidden')
  }
}

/**
 * Update cart items section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartItems = async (str) => {
  assignDiffCarts(str);
  setQuantity();
  deleteItem();
  await onChangeItemCart();

  if (sessionStorage.getItem('vintega_discount_applied')) {
    $Q('.cart-discount__apply').click();
  }
}

/**
 * Update checkout button section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
 export const updateCartbutton = (str) => {
  const btnContainer = $Q('.cart-footer', stringToHTML(str));
  const domBtnContainer = $Qll('#container-footer-js');

  if (btnContainer) {
    domBtnContainer.forEach((element) => {
      const elementRef = element;
      elementRef.innerHTML = btnContainer.outerHTML;
    })

    return;
  }

  domBtnContainer.forEach((element) => {
    const elementRef = element;
    elementRef.innerHTML = '';
  })

}

/**
 * Chance all input value only cart page
 *
 * @param {String} id - Variant id item cart
 * @param {String} quantity - Quantity variant by item cart
 */
 const updateQuantity = (id, quantity) => {
  $Qll(`.item-cart-js[id="${id}"]`).forEach(
    (element) => {
      const elementRef = element;
      elementRef.value = quantity
    }
  )
}

/**
 * Update price item for each item in cart items section
 * @param {string} str - String HTML of section rendeirng
 * @param {number} id - Product ID
 */
export const updatePriceItem = (str, id) => {

  const {
    dataset,
    outerText,
  } = $Q(`#price-${id}`, stringToHTML(str));

  $Qll(`.price-${id}`).forEach(
    (element) => {
      const elementRef = element;
      elementRef.innerHTML = outerText
    }
  )

  updateQuantity(id, dataset.quantity);
}

/**
 * Update total price in cart page
 * @param {string} str - String HTML of section rendeirng
 */
 export const updatetotalPrice = (str) => {
  if ($Q(".cartpage-footer__info--price") != null) {
    const totalPriceElement = $Q("#total-price", stringToHTML(str));
    if (totalPriceElement) {
      return $Q(".cartpage-footer__info--price").innerHTML = totalPriceElement.outerText;
    } else {
      return $Q(".cartpage-footer__info--price").innerHTML = '0';
    }
  }
}

/**
 * Update upsell section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
 export const updateUpsell = (str) => {
  const element = $Q('#upsell-js');
  const content = $Q(
    '#cart-upsell-slider',
    stringToHTML(str)
  ).outerHTML;

  if (!element)  return;

  element.innerHTML = content;

  btnAddToCart(".add-product-cart-upsell");
  configUpsellCart();
}

/**
 * Update upsell section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartpageUpsell = (str) => {
  const element = $Q('#cartpage-upsell-js');
  const sliderElement = $Q('#cartpage-upsell-slider');
  
  if (!element || !sliderElement) return;

  element.innerHTML = sliderElement.outerHTML;

  btnAddToCart("#cartpage-upsell-js .add-product-cart");
  configArrows('#cartpage-upsell-slider #slider_cart-slider');
}
